module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-stroke.c45f7de0.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/styles/icons/pe-icon-7-stroke/fonts/Pe-icon-7-stroke.svg?d7yf1v
 ** module id = 1606
 ** module chunks = 0
 **/